import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { BaseCell } from '@warrenbrasil/nebraska-web';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  risk: { label: string; value: string };
  align?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RiskCell',
  props: {
    risk: null,
    align: { default: 'right' }
  },
  setup(__props: any) {

const { risk } = __props as { risk: { label: string; value: string }, align: string };



const bulletColor: { [key: string]: NebraskaColors } = {
  LOW: NebraskaColors.riskLow,
  MEDIUM: NebraskaColors.riskMedium,
  HIGH: NebraskaColors.riskHigh
};

const bulletStyle = computed(() => {
  return { backgroundColor: bulletColor[risk.value] };
});

return { __sfc: true,risk, bulletColor, bulletStyle, BaseCell }
}

})